import { Fragment, useEffect, useState } from "react";
import { IconPlus } from "../../assets/svgs-index";
import { Company } from "../../core/models/company.model";
import { Helper } from "../../core/services/helper/helper.service";
import './CompanyCard.scss';
import LinkButton from "../../components/buttons/LinkButton/LinkButton";

interface CompanyCardProps {
  company: Company | undefined,
  isDetailsCard?: boolean,
  onClick?: (c: Company) => void
}
const CompanyCard = (props: CompanyCardProps) => {
  const { isDetailsCard } = props;
  const cardStyle = isDetailsCard ? 'w-100 h-auto d-inline-flex' : '';
  const [company, setPropValue] = useState(props.company);

  useEffect(() => {
    setPropValue(props.company);
  }, [props.company]);


  // const handleClickLocalization = () => {
  //   console.log('handle open localization', company?.geo);
  // }

  const renderLogoContainer = () => {
    const renderAddButton = () => {
      if (isDetailsCard) {
        return (<Fragment />);
      }
      return (
        <div className="add-button-container">
          <img src={IconPlus} alt="add-company" />
        </div>
      );
    }
    const renderImg = () => {
      if (!company || !company.logoUrl) {
        return <div className="company-name-logo">{company?.name}</div>;
      }
      return <img src={company.logoUrl} alt="company_logo" />;
    };
    return (
      <div
        className="company-logo"
        onClick={() => {
          if (props.onClick && company) {
            props.onClick(company);
          }
        }}
      >
        {/* <img
          src={company?.logoUrl || Logo}
          alt="company-logo"
          onError={(e) => ((e.target as HTMLImageElement).src = Logo)}
        /> */}
        {renderImg()}
        {renderAddButton()}
      </div>
    );
  }

  const renderLocalization = () => {
    return (
      <div
        className={`company-localization ${isDetailsCard ? "details" : ""
          } mt-1 d-inline-flex justify-content-between align-items-center`}
      >
        {/*<span>{company?.town}</span> */}
         <LinkButton
          onClick={() => { }}
          styleClass={`link-container ${isDetailsCard ? "details" : ""}`}
          textClass="small"
          isMaps={isDetailsCard}
          valueLink={isDetailsCard ? company?.name + ', ' + company?.address : undefined}
          valueText={company?.town}
          isDetailsCard={isDetailsCard}
        /> 
        {renderDistance()}
      </div>
    );
  }

  const renderDistance = () => {
    if (!company?.distance) {
      return <Fragment></Fragment>;
    }

    return (
      <div className="distance ms-1">
        {company?.distance ? Helper.formatDistance(company?.distance) : ""}
      </div>
    );
  };

  return (
    <div className={`company-card ${cardStyle}`} role="button" id="company-card">
      {renderLogoContainer()}
      <div className={`company-info ${isDetailsCard ? 'ms-3' : ''}`}>
        <div className={`mt-1 company-name${isDetailsCard ? ' details' : ''}`}>{company?.name}</div>
        {renderLocalization()}
      </div>
    </div>
  );
}

export default CompanyCard;
